import { MessagingCampaignDetailsFragment } from '@occc/graphql';

import { TestMessageTemplateInput } from './send-test-message.types';

export const messagingCampaignDetailsFragmentToTestMessageTemplateInput = (
  fragment: MessagingCampaignDetailsFragment,
): TestMessageTemplateInput => {
  const template = fragment.channelsConfig?.pushNotificationConfig?.template;

  return {
    smsBody: fragment.channelsConfig?.smsConfig?.body || null,
    pushNotificationTemplate: template
      ? {
          notification: {
            // Title is optional on the campaign (OCST-29535) but required to send a test push —
            // falling back to '' leaves canSendTestPush false rather than failing schema validation.
            title: template.notification.title ?? '',
            body: template.notification.body,
          },
          data: template.data,
        }
      : null,
  };
};
